import { SET_ACCESS_TOKEN } from './types';

export const setAccessToken = (accessToken, customerId, origin) => dispatch => {
  dispatch({
    type: SET_ACCESS_TOKEN,
    data: { accessToken, customerId, origin },
  });
};
